module.exports = __webpack_public_path__ + "static/img/13.9f57d39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/13.png
// module id = IObi
// module chunks = 0